export default __webpack_public_path__ + "static/media/rolesDelete.6cf98eb2.svg";